//TODO: GROW-2166 when Productizing if fixed win update the InverseHeader in core component and fix imports
import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import InverseHeader from '@/app/components/Experiments/FixedHeader/InverseHeader/InverseHeader';
import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';

export const NewsroomHero = () => {
  const t = useTranslations();
  return (
    <section data-cy="newsroom-hero-section">
      <InverseHeader enter>
        <LayoutGrid>
          <GridItem
            className="relative"
            colEnd={{ sm: 'full' }}
            colStart={{ sm: 'full' }}
            rowEnd={{ sm: 2 }}
            rowStart={{ sm: 1 }}
          >
            <ArtDirectionImage
              localizedAlt="press_hero_image_alt_text"
              className="object-cover"
              fill
              format="png"
              sizes="(max-width: 767px) 100vw, 25vw"
              srcSet={[
                {
                  src: 'press/press-hero-mobile',
                  media: '(max-width: 767px)',
                },
                {
                  src: 'press/press-hero-desktop2x',
                  media: '(min-width: 768px)',
                },
              ]}
            />
          </GridItem>
          <GridItem
            className="relative py-64 lg:py-60"
            colEnd={{ sm: 'main' }}
            colStart={{ sm: 'main' }}
            rowEnd={{ sm: 2 }}
            rowStart={{ sm: 1 }}
          >
            <TypographyV3
              Element="h1"
              variant="h4"
              color="light"
              className="mb-4"
            >
              {t('newsroom_link')}
            </TypographyV3>
            <TypographyV3 variant="h1" color="light">
              {t('press_title_subheading')}
            </TypographyV3>
          </GridItem>
        </LayoutGrid>
      </InverseHeader>
    </section>
  );
};
